import { CaseFolderObject } from '../models/DataAdminTypes';

export const getImmediateFolderObjects = 
  (folderObjects: CaseFolderObject[], currentFolder: string): CaseFolderObject[] => {
    const filteredObjects = folderObjects.filter(obj => 
      currentFolder === '' || obj.filePathSansCaseFolder.startsWith(currentFolder + '/')
    );
    const displayObjects: CaseFolderObject[] = [];
    const seenSubfolders = new Map<string, CaseFolderObject>();

    for (const obj of filteredObjects) {
      // if there is no further '/' after the selectedFolder, it's a file in the current level
      const remainingPath = currentFolder === '' ? obj.filePathSansCaseFolder : obj.filePathSansCaseFolder.slice(currentFolder.length + 1);
      if (obj.filePathSansCaseFolder === '') {
        // Skip "empty" root folder objects
        continue;
      } else if (!remainingPath.includes('/')) {
        displayObjects.push(obj);
      } else {
        const currentSubfolder = remainingPath.split('/')[0];
        if (!seenSubfolders.has(currentSubfolder)) {
          seenSubfolders.set(currentSubfolder, obj);
        } else {
          // Update to the most recently modified object in the subfolder
          const existing = seenSubfolders.get(currentSubfolder);
          if (existing && obj.lastModified && (!existing.lastModified || (obj.lastModified > existing.lastModified))) {
            seenSubfolders.set(currentSubfolder, obj);
          }
        }
      }
    }

    // Add 'virtual' subfolder entries for UI display
    seenSubfolders.forEach((obj, subfolder) => {
      displayObjects.push({
        objectKey: `${currentFolder ? currentFolder + '/' : ''}${subfolder}`,
        filePathSansCaseFolder: `${currentFolder ? currentFolder + '/' : ''}${subfolder}`,
        isFolder: true,
        isSubFolder: true,
        lastModified: obj.lastModified,
        size: undefined,
        sizeDesc: 'Folder'
      });
    });

    return displayObjects;
  };
